import * as React from 'react';
import ContentContainer from '../Content/ContentContainer';
import * as UserActionCreators from "../../actions/user.actions";
import * as classNames from "classnames";
import * as DTOS from "../../FeralScan.dtos";
import { withTheme } from '../../common/withTheme';
import { LocalForm, Control } from 'react-redux-form';
import PasswordChange from './PasswordChange';
import * as Configuration from '../../configuration';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { IAppState } from '../../app';
import InternalAbsoluteLink from '../Framework/Common/Links/InternalAbsoluteLink';

interface PasswordResetActions {
}

interface IPasswordResetPropsMapped {
    sendPasswordReset?: typeof UserActionCreators.sendPasswordReset;
    changePasswordFromToken?: typeof UserActionCreators.changePasswordFromToken;
    changePassword?: typeof UserActionCreators.changePassword,
}

interface PasswordResetProps {
    currentUser: DTOS.User;
    changePasswordToken?: string;
    loginActive: boolean;
    theme?: string;
}

export type PasswordResetPropsAndActions = PasswordResetProps & IPasswordResetPropsMapped & PasswordResetActions;

class PasswordReset extends React.PureComponent<PasswordResetPropsAndActions, any> {
    formDispatch;
    constructor(props, context) {
        super(props, context);
        this.onRequestPasswordReset = this.onRequestPasswordReset.bind(this);

        this.state = { requestMade: false }
    }

    componentDidMount() {
    }

    componentDidUpdate() {
    }

    onRequestPasswordReset(username: string) {
        this.props.sendPasswordReset(username);
        this.setState({ requestMade: true });
    }

    render() {
        const loggedIn: boolean = this.props.currentUser && this.props.loginActive;

        return (
            <div className="mx-lg-3 mt-3 col-md-6 col-12">
                {
                    this.state.requestMade ?
                        <div className="text-center">
                            <h3>If an account exists for the email you provided we have now sent instructions on how to reset your password to it.</h3>
                            {
                                InternalAbsoluteLink("/", "Return to site", undefined, "btn btn-lg btn-primary my-4")
                            }
                        </div>
                        :
                        loggedIn || this.props.changePasswordToken ?
                            <PasswordChange
                                currentUser={this.props.currentUser}
                                loginActive={this.props.loginActive}

                                changePassword={this.props.changePassword}
                                changePasswordFromToken={this.props.changePasswordFromToken}
                                changePasswordToken={this.props.changePasswordToken}
                            /> :
                            <LocalForm
                                model="passwordReset"
                                className={classNames(this.props.theme, "form password-form")}
                                onSubmit={passwordReset => this.onRequestPasswordReset(passwordReset.username)}
                                getDispatch={(dispatch) => this.formDispatch = dispatch}
                                validateOn="submit">
                                <h3>Password Reset</h3>
                                {this.props.children}
                                <div className="form-fields">
                                    <label className="lead my-0">Email</label>
                                    <Control.text
                                        model=".username"
                                        id="passwordReset.username"
                                        className="form-control form-control-sm mb-2"
                                        maxLength={100}
                                        required={true}
                                    />
                                    <button className={classNames(this.props.theme, "btn btn-primary btn-lg mt-2 align-self-end")}>SEND</button>
                                </div>
                            </LocalForm>
                }
            </div>
        );
    }
}

const mapStateToProps = (state: IAppState, ownProps: PasswordResetPropsAndActions): IPasswordResetPropsMapped => {

    return {
    }
}

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({
        sendPasswordReset: UserActionCreators.sendPasswordReset,
        changePasswordFromToken: UserActionCreators.changePasswordFromToken,
        changePassword: UserActionCreators.changePassword,
    }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(withTheme<PasswordResetPropsAndActions>(PasswordReset));